import { render } from "./StoreBadges.vue?vue&type=template&id=7cb35bb0&scoped=true"
import script from "./StoreBadges.vue?vue&type=script&lang=js"
export * from "./StoreBadges.vue?vue&type=script&lang=js"

import "./StoreBadges.vue?vue&type=style&index=0&id=7cb35bb0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb35bb0"]])

export default __exports__